module.exports = "https://static-www.niulinkcloud.com/_next/static/media/mobileBanner0.223cb3ca93436a0b91e482cea5d1e583.png";